<a
  [routerLink]="routerLink()"
  [routerLinkActive]="['sidebar-item-v2--active']"
  [routerLinkActiveOptions]="activeOptions()"
  class="sidebar-item-v2">
  <div class="sidebar-item-v2__icon">
    <ng-container *ngComponentOutlet="icon()"></ng-container>
  </div>
  <div class="sidebar-item-v2__label body-xs">
    {{ label() }}
  </div>
</a>
